<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 0; overflow: hidden;position: fixed; background-size: cover;"
         :style="{ backgroundImage:`linear-gradient(-45deg, rgba(7, 44, 90, 0.97),rgba(255, 255, 255, 0)), url('${Background}')`}"
    >
        <div style="position: relative;top: 50%;transform: translateY(-50%)">
            <v-img
                    :src="Logo"
                    :style="{'width':'50%','max-width': '400px','margin': 'auto', 'margin-bottom':'40px'}"
            />
            <h1 class="ui header" style="color: white;font-size: 5rem;">SatView</h1>
            <h1 class="ui header" style="color: white;margin-bottom: 40px;font-weight: 500;">
                Сервис для заказа снимков с малого космического аппарата "Аист-2Д"
            </h1>
            <v-firebaseui/>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import Background from '@/img/background.jpg'
    import Logo from '@/img/logo.png'

    import VFirebaseui from '@/components/v-firebaseui/v-firebaseui'

    export default {
        props: {},
        data() {
            return {
                Background,
                Logo
            }
        },
        computed: {},
        methods: {},

        components: {
            VFirebaseui
        }

    }
</script>

<style scoped>

</style>
